export const getCategory = url => {
  switch (url) {
    case 'collections':
      return 'domestic';
    case 'deliveries':
      return 'domestic';
    case 'subcontracts_in':
      return 'subcontracted';
    case 'subcontracts_out':
      return 'subcontracted';
    case 'imports':
      return 'international';
    case 'exports':
      return 'international';
  }
};

export const getMovementType = url => {
  switch (url) {
    case 'collections':
      return 'collections';
    case 'deliveries':
      return 'deliveries';
    case 'subcontracts_in':
      return 'collections';
    case 'subcontracts_out':
      return 'deliveries';
    case 'imports':
      return 'imports';
    case 'exports':
      return 'exports';
  }
};
